module.exports = __webpack_public_path__ + "static/media/IconTelefone.511f010f.svg";